import { createReducer, on } from "@ngrx/store";
import { HttpErrorResponse } from "@angular/common/http";
import {
  invitedStudentsListLoad,
  invitedStudentsListLoadFail,
  invitedStudentsListLoadSuccess,
} from "../../actions/admin/invited-students.actions";
import {
  InvitedStudentsPerTeacher,
  InvitedUser,
} from "src/app/shared/interfaces/orgadmin/invited-students";
import { deleteInvitationStudentLoadSuccess } from "../../actions/admin/delete-invitation-student.action";
import { Pagination } from "src/app/shared/interfaces/pagination";

export interface InvitedStudentsListState {
  students: InvitedStudentsPerTeacher[];
  invitations: InvitedUser[];
  pagination: Pagination | null;
  pageSize: number;
  loading: boolean;
  error: HttpErrorResponse | null;
}

const initialState: InvitedStudentsListState = {
  students: [],
  invitations: [],
  pagination: null,
  pageSize: 50,
  loading: true,
  error: null,
};

export const invitedStudentsListReducer = createReducer(
  initialState,
  on(
    invitedStudentsListLoad,
    (state): InvitedStudentsListState => ({
      ...state,
      loading: true,
      error: null,
    }),
  ),
  on(
    invitedStudentsListLoadSuccess,
    (state, action): InvitedStudentsListState => {
      const invitations = action.paginatedStudents
        ? action.paginatedStudents.results ?? []
        : action.invitedStudents.reduce<InvitedUser[]>(
            (items, teacher) => items.concat(teacher.invitations ?? []),
            [],
          );

      return {
        ...state,
        students: action.invitedStudents,
        invitations,
        pagination: action.paginatedStudents
          ? {
              page: action.page ?? 1,
              page_last: action.paginatedStudents.page_count,
              position_last: action.paginatedStudents.result_count,
            }
          : null,
        pageSize: action.pageSize ?? state.pageSize,
        loading: false,
        error: null,
      };
    },
  ),
  on(
    deleteInvitationStudentLoadSuccess,
    (state, { invitationId }): InvitedStudentsListState => ({
      ...state,
      invitations: state.invitations.filter(
        (invitation) => invitation.id !== invitationId,
      ),
      pagination: state.pagination
        ? {
            ...state.pagination,
            page_last: Math.max(
              Math.ceil((state.pagination.position_last - 1) / state.pageSize),
              1,
            ),
            position_last: Math.max(state.pagination.position_last - 1, 0),
          }
        : state.pagination,
      students: state.students.map((teacher) => ({
        ...teacher,
        invitations: (teacher.invitations ?? []).filter(
          (invitation) => invitation.id !== invitationId,
        ),
      })),
    }),
  ),
  on(
    invitedStudentsListLoadFail,
    (state, { error }): InvitedStudentsListState => ({
      ...state,
      loading: false,
      error,
    }),
  ),
);
